import NotificationMixin from 'aa/vue/plugins/NotificationMixin';
import PageAttributeMixin from 'aa/vue/plugins/purchaseFunnel/PageAttributeMixin';

export default {
    install: (Vue) => {
        Vue.mixin(NotificationMixin);
        Vue.mixin(PageAttributeMixin);
    },
};
